import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faUpload } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import moment from 'moment';

const AcaoCard = ({ acao }) => {

    const history = useHistory();

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                Título:
            </div>
            <div className={styles.info}>
                {acao.titulo}
            </div>
            <div className={styles.title}>
                Ordem:
            </div>
            <div className={styles.info}>
                {acao.ordem}
            </div>
            <div className={styles.title}>
                Período De
            </div>
            <div className={styles.info}>
                {new moment(acao.dataDe).format('DD/MM/YYYY') }
            </div>
            <div className={styles.title}>
                Periodo Até:
            </div>
            <div className={styles.info}>
                {new moment(acao.dataAte).format('DD/MM/YYYY')}
            </div>
            <div className={styles.title}>
                Total de pontos:
            </div>
            <div className={styles.info}>
                {acao.pontos}
            </div>
            <div className={styles.actionWrapper}>

                { acao.status === 2 && (<div className={styles.encerrado}>RASCUNHO</div>) }
                { acao.status === 1 && (<div className={styles.andamento}>ATIVO</div>) }
                {  acao.status === 0 && (<div className={styles.inativo}>INATIVO</div>) }
                
                <button className={styles.editar} onClick={() => {history.push(`/treinamentos/adicionar?treinamento=${acao.treinamentoId}`)}}>
                    Editar
                    <FontAwesomeIcon icon={faUpload} className={styles.icon}/>
                </button>
            </div>
        </div>
    )
}

export default AcaoCard